import React, { useState } from "react";
import "./SkillsSectionss.css";
import tailwind from "../../images/tailwind-css-2.svg";
import javascript from "../../images/logo-javascript.svg";
import react from "../../images/react-2.svg";
import node from "../../images/nodejs-1.svg";
import express from "../../images/exprsss.png";
import git from "../../images/git.png";
import github from "../../images/github.png";

import figma from "../../images/figma.png";
import vscode from "../../images/vscode (2).png";
import postman from "../../images/postman.png";

const SkillsSection = () => {
  const [toggleState, setToggleState] = useState(1);
  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <>
      <div className="row">
        <div className="about-tabs">
          <span
            className={
              toggleState === 1 ? "tab-item  active-tab-item" : "tab-item"
            }
            onClick={() => toggleTab(1)}
          >
            Skills
          </span>
          <span
            className={
              toggleState === 2 ? "tab-item  active-tab-item" : "tab-item"
            }
            onClick={() => toggleTab(2)}
          >
            Education
          </span>
        </div>
      </div>

      <div className="skills faq-container ">
        <div
          className={
            toggleState === 1
              ? "tab-content tab-content-actives "
              : "tab-content"
          }
          onClick={() => toggleTab(1)}
        >
          <h1>👉 Technologies Familiar with</h1>
          <div className="skillsimages">
            <img src={tailwind} alt="tailwindcss" />
            <img src={javascript} alt="javascript" />
            <img src={react} alt="react" />
            <img src={express} alt="expreejs" />
            <img src={node} alt="nodejs" />
          </div>
          <h1>👉 Tools I Used</h1>
          <div className="skillsimages ">
            <img src={git} alt="tailwindcss" />

            <img src={github} alt="github" />
            <img src={figma} alt="figma" />
            <img src={vscode} alt="vscode" />
            <img src={postman} alt="postman" />
          </div>
        </div>
      </div>

      <div
        className={
          toggleState === 2
            ? "tab-content tab-content-actives  "
            : "tab-content"
        }
        onClick={() => toggleTab(2)}
      >
        <div className="education-container">
          <h2>HighSchool</h2>
          <p>Maharishi Vidya Mandir,Bageshwar</p>
          <p>2016</p>
          <hr></hr>
          <h2>Intermediate</h2>
          <p>Maharishi Vidya Mandir,Bageshwar</p>
          <p>2018</p>
          <hr></hr>
          <h2>Bachelor of technology</h2>
          <p>Amrapali Group of Institues,Haldwani</p>
          <p>2023</p>
        </div>
      </div>
    </>
  );
};

export default SkillsSection;
